import {
    get,
    isEqual,
    sortBy
} from 'lodash';
import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';
import {
    GATEWAYS_FAILURE,
    GATEWAYS_LOAD,
    GATEWAYS_SUCCESS
} from './gatewaysActions';

export function gatewaysMapper(action) {
    let gateways = sortBy(get(action, 'gateways', []), ['name']);

    return gateways.reduce((acc, item) => {
        acc[item.id] = item.name;

        return acc;
    }, {});
}

export default function reducer(state = {
    gatewayMap: {},
    gateways: {}
}, action = {}) {
    let newState;

    switch (action.type) {
        case GATEWAYS_LOAD:
            newState = {
                ...state,
                error: null,
                loaded: false,
                loading: true,
                gateways: {}
            };

            return isEqual(state, newState) ? state : newState;

        case GATEWAYS_SUCCESS:
            newState = {
                ...state,
                loaded: true,
                loading: false,
                gatewayMap: gatewaysMapper(action),
                gateways: action.gateways
            };

            return isEqual(state, newState) ? state : newState;

        case GATEWAYS_FAILURE:
            newState = {
                ...state,
                error: action.error,
                loading: false,
                gateways: {}
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getGatewaysEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'gateways')
);

export const getIsGatewaysLoaded = createSelector(
    getGatewaysEntity,
    (entity) => get(entity, 'loaded')
);

export const getIsGatewaysLoading = createSelector(
    getGatewaysEntity,
    (entity) => get(entity, 'loading')
);

export const getGateways = createSelector(
    getGatewaysEntity,
    (entity) => {
        return get(entity, 'gateways');
    }
);

